import { render, staticRenderFns } from "./Subtopics.vue?vue&type=template&id=545c864a&"
import script from "./Subtopics.vue?vue&type=script&lang=js&"
export * from "./Subtopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports